import React, { useEffect, useState } from "react";
import Lottie from "react-lottie";
import { remoteConfig } from "@config/firebase";
import { getValue } from "firebase/remote-config";

import { useRemoteConfigValues } from "@hooks";
import {
  TERMS_AND_CONDITIONS,
  TERMS_AND_CONDITIONS_GIFT_CARD,
} from "@utils/globalConstants";
import animation from "@animations";

export default function TermsAndConditions({ isGiftCard = false }) {
  const isReady = useRemoteConfigValues();
  const [terms, setTerms] = useState({});

  const defaultLottieOptions = {
    loop: true,
    autoplay: true,
    animationData: animation.loadingBlue,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  useEffect(() => {
    if (isReady) {
      setTerms(
        JSON.parse(
          getValue(
            remoteConfig,
            isGiftCard ? TERMS_AND_CONDITIONS_GIFT_CARD : TERMS_AND_CONDITIONS,
          )._value,
        ),
      );
    }
  }, [isReady, isGiftCard]);

  if (isReady) return <div dangerouslySetInnerHTML={{ __html: terms.text }} />;

  return <Lottie options={defaultLottieOptions} height={120} width={120} />;
}
